module.exports = flarum.core.compat['components/Button'];